import { TopButtons } from "./topbar/TopButtons";

interface Page {
    titulo: string;
    children: any;
}
export const BasicPage = ({ titulo, children }: Page) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-6">
                        <h5>{titulo}</h5>
                    </div>
                    <div className="col-md-6">
                        <TopButtons />
                    </div>
                    <div className="col-md-12">
                        <hr style={{marginTop:-5}} />
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                {children}
            </div>
        </div>
    )
}